/* SERVICE_TYPES — 21 canonical service types (verbatim from mockup core.js). */
export const SERVICE_TYPES = [
  {code: 'FWD_SURFACE_REG', name: 'Forward Surface — Regular', cat: 'Ground Forward', wt: '≤ 5 kg', cod: 'Yes'},
  {code: 'FWD_SURFACE_LARGE', name: 'Forward Surface — Large', cat: 'Ground Forward', wt: '5–30 kg', cod: 'Yes'},
  {code: 'FWD_AIR_REG', name: 'Forward Air — Regular', cat: 'Air Forward', wt: '≤ 2 kg', cod: 'No'},
  {code: 'FWD_AIR_LARGE', name: 'Forward Air — Large', cat: 'Air Forward', wt: '2–10 kg', cod: 'No'},
  {code: 'REV_REG_NOQC', name: 'Reverse — Regular, No QC', cat: 'Returns', wt: '≤ 5 kg', cod: 'N/A'},
  {code: 'REV_REG_QC', name: 'Reverse — Regular, With QC', cat: 'Returns', wt: '≤ 5 kg', cod: 'N/A'},
  {code: 'REV_LARGE_NOQC', name: 'Reverse — Large, No QC', cat: 'Returns', wt: '5–30 kg', cod: 'N/A'},
  {code: 'REV_LARGE_QC', name: 'Reverse — Large, With QC', cat: 'Returns', wt: '5–30 kg', cod: 'N/A'},
  {
    code: 'HV_FWD_REG',
    name: 'High Value Forward — Regular',
    cat: 'High Value',
    wt: '≤ 5 kg',
    cod: 'Yes',
    note: 'Replaces VP / Value Plus effective May 2026. Requires in-transit insurance and mandatory signature POD.',
  },
  {code: 'HV_FWD_LARGE', name: 'High Value Forward — Large', cat: 'High Value', wt: '5–30 kg', cod: 'Yes'},
  {code: 'HV_REVERSE_REG', name: 'High Value Reverse — Regular', cat: 'High Value', wt: '≤ 5 kg', cod: 'N/A'},
  {code: 'HV_REVERSE_LARGE', name: 'High Value Reverse — Large', cat: 'High Value', wt: '5–30 kg', cod: 'N/A'},
  {code: 'SDD_FWD_REG', name: 'Same-Day Delivery — Regular', cat: 'Same Day', wt: '≤ 5 kg', cod: 'Yes'},
  {code: 'SDD_FWD_LARGE', name: 'Same-Day Delivery — Large', cat: 'Same Day', wt: '5–10 kg', cod: 'Yes'},
  {code: 'SC_NDD_FWD_REG', name: 'Same City NDD — Regular', cat: 'Next Day', wt: '≤ 5 kg', cod: 'Yes'},
  {code: 'SC_NDD_FWD_LARGE', name: 'Same City NDD — Large', cat: 'Next Day', wt: '5–10 kg', cod: 'Yes'},
  {code: 'INTERCITY_NDD_REG', name: 'Intercity NDD — Regular', cat: 'Next Day', wt: '≤ 5 kg', cod: 'Yes'},
  {code: 'INTERCITY_NDD_LARGE', name: 'Intercity NDD — Large', cat: 'Next Day', wt: '5–10 kg', cod: 'Yes'},
  {code: 'SUB4H', name: 'Sub-4 Hour Delivery', cat: 'Hyperlocal', wt: '≤ 3 kg', cod: 'Yes'},
  {code: 'H2TO4', name: '2–4 Hour Delivery', cat: 'Hyperlocal', wt: '≤ 3 kg', cod: 'Yes'},
  {code: 'SUB2H', name: 'Sub-2 Hour Delivery', cat: 'Hyperlocal', wt: '≤ 2 kg', cod: 'Yes'},
]

export const SERVICE_TYPES_BY_CODE = SERVICE_TYPES.reduce((m, s) => {
  m[s.code] = s
  return m
}, {})

export const deliveryModesOf = (serviceTypes) => {
  const MAP = [
    {label: 'Surface', re: /^FWD_SURFACE/},
    {label: 'Air', re: /^FWD_AIR/},
    {label: 'SDD', re: /^SDD_/},
    {label: 'Same-City NDD', re: /^SC_NDD/},
    {label: 'Intercity NDD', re: /^INTERCITY_NDD/},
    {label: '2–4h', re: /^(H2TO4|SUB4H)/},
    {label: 'Sub-2h', re: /^SUB2H/},
    {label: 'High Value', re: /^HV_/},
    {label: 'Reverse', re: /^REV_/},
  ]
  const seen = {}, out = []
  ;(serviceTypes || []).forEach((st) => {
    for (let i = 0; i < MAP.length; i++) {
      if (MAP[i].re.test(st) && !seen[MAP[i].label]) { seen[MAP[i].label] = true; out.push(MAP[i].label); break }
    }
  })
  return out
}
